(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/utils/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/pool-betting/utils/assets/javascripts/constants.js');
"use strict";


const CANCELLED_DRAW_TEXT = 'Omgången är inställd.  Alla insatser är återbetalda.';
setGlobal('svs.components.poolBetting.utils.constants', {
  CANCELLED_DRAW_TEXT
});

 })(window);